import { mapToListboxItems } from '@oncolens/oncolens-ui/lib/components/FormControls/Listbox';
import { useMemo } from 'react';
import { useOrganizations } from './api/organizations';

export function useOrganizationData() {
  const { data: organizationData } = useOrganizations({ pageSize: 500 });
  return useMemo(
    () =>
      mapToListboxItems(
        organizationData?.data || [],
        (org) => org.name,
        (org) => org.id,
      ),
    [organizationData],
  );
}
